import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCampaignSubject,
  setCampaignABTestSubject,
  setComplaiceStatus,
} from 'ReduxStore/Slices/campaignSlice';

export default function CampaignSubject() {
  const dispatch = useDispatch();
  const {
    campaignABTestEnabled,
    campaignABTestChecked,
    campaingABTestData,
    campaignSubject,
    campaignViewMode
  } = useSelector((state) => state.campaignSetter);
  const subjectRef = useRef();
  const abTestSubjectARef = useRef();
  const abTestSubjectBRef = useRef();

  useEffect(() => {

    if (
      campaignABTestEnabled &&
      campaignABTestChecked &&
      campaingABTestData.campaignABTestVariation === 'Subject'
    ) {
      abTestSubjectARef.current.value = campaignSubject;
      abTestSubjectBRef.current.value = campaingABTestData.campaignABTestSubject;
    } else {
      subjectRef.current.value = campaignSubject;
    }
  }, [campaignSubject, campaingABTestData.campaignABTestVariation]);
  return (
    <div className='row justify-content-between align-items-end pt_15'>
      <div className='left_sec'>
        <div className='max534'>
          <label>Subject</label>
          <p className='campaign_text'>
            What's the subject line for this campaign?
          </p>
        </div>
      </div>
      <div className='right_sec'>
        {campaignABTestEnabled &&
          campaignABTestChecked &&
          campaingABTestData.campaignABTestVariation === 'Subject' ? (
          <div className='d-flex flex-row'>
            <input
              onChange={(e) => {
                dispatch(setCampaignSubject(e.target.value));
                dispatch(setComplaiceStatus('Editing'));
              }}
              id='subject'
              className='kwDesign max359'
              type='text'
              required
              ref={abTestSubjectARef}
              placeholder='Subject A'
              disabled={campaignViewMode}
            />{' '}
            <input
              onChange={(e) => {
                dispatch(setCampaignABTestSubject(e.target.value));
                dispatch(setComplaiceStatus('Editing'));
              }}
              id='subject'
              className='kwDesign max359 ml-2'
              type='text'
              required
              ref={abTestSubjectBRef}
              placeholder='Subject B'
              disabled={campaignViewMode}
            />
          </div>
        ) : (
          <input
            onChange={(e) => {
              dispatch(setCampaignSubject(e.target.value));
              dispatch(setComplaiceStatus('Editing'));
            }}
            id='subject'
            className='kwDesign max359'
            type='text'
            required
            ref={subjectRef}
            disabled={campaignViewMode}
          />
        )}
      </div>
    </div>
  );
}
